<script lang="ts">
	import { page } from '$app/stores';
	import { cart, deviceWidth } from '$lib/stores';
	import { mobileBreakPoint } from '$lib/utils/constants';
	import { drawerStore, type DrawerSettings } from '@skeletonlabs/skeleton';
	import { Bars4, CartO, UserO } from '@svg';
	import { fade } from 'svelte/transition';

	export let showMainLinks = true,
		showExtraLinks = true;

	$: currentPage = $page.url.pathname;

	const pages = [
		{ title: 'Inicio', href: '/' },
		{ title: 'Categorías', href: '/categorias' },
		{ title: 'Nosotros', href: '/nosotros#Nosotros' }
	];

	$: totalAmount = $cart.reduce((accumulator, currentValue) => accumulator + currentValue.amount, 0);

	const drawerCartSettings: { mobile: DrawerSettings; desktop: DrawerSettings } = {
		mobile: {
			id: 'cart',
			position: 'top',
			height: 'h-max max-h-full'
		},
		desktop: {
			id: 'cart',
			position: 'right',
			width: 'max-w-xl',
			height: 'h-max max-h-full',
			padding: 'p-4 pr-0'
		}
	};
</script>

<nav transition:fade|local class="w-max">
	<ul class="flex flex-row space-x-4">
		{#if showMainLinks && $deviceWidth > mobileBreakPoint}
			{#each pages as { href, title }}
				<li class={currentPage === href ? 'underline' : ''}><a {href}>{title}</a></li>
			{/each}
		{/if}
		{#if showExtraLinks}
			<a href="/cuenta" class="hidden sm:block"><UserO /></a>
			<button
				class="btn-styless relative"
				on:click={() =>
					drawerStore.open($deviceWidth <= mobileBreakPoint ? drawerCartSettings.mobile : drawerCartSettings.desktop)}
			>
				<CartO />
				{#key $cart}
					<span
						class="absolute -top-4 rounded-full bg-primary-500 p-[3px] leading-none text-sm
					{$cart.length === 0 && 'hidden'}
					{totalAmount > 9 ? 'left-1' : 'right-1'}
				"
						transition:fade|local
					>
						{totalAmount}
					</span>
				{/key}
			</button>

			{#if $deviceWidth <= mobileBreakPoint}
				<button
					class="btn-styless"
					on:click={() =>
						drawerStore.open({
							id: 'mobileMenu',
							position: 'left',
							width: 'max-w-xl',
							height: 'h-max max-h-full',
							padding: 'py-4'
						})}
				>
					<Bars4 />
				</button>
			{/if}
		{/if}
	</ul>
</nav>
